import React, {useEffect, useRef, useState} from "react";
import {Divider, IconButton, InputBase, Paper, styled, Tooltip} from "@mui/material";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import RefreshIcon from '@mui/icons-material/Refresh';
import {pink} from "@mui/material/colors";
import SaveIcon from '@mui/icons-material/Save';
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import {CustomBackdrop} from "../utils/customStyles";
import ShowSnackbar from "../utils/ShowSnackbar";

const StyledPaper = styled(Paper) ({
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '70%',
    marginTop: '10px',
})
export const StyledDivider = styled(Divider)({
    height: 28,
})
const nonIndividualSuffix = '/ValueSet-NonIndividualSpecialtiesVS.json'
const individualSuffix = '/ValueSet-IndividualAndGroupSpecialtiesVS.json'

export default function NuccSpecialtyValueSetPagePasteURLPanel (props) {
    const urlRef = useRef(null);
    const setNuccDataPath = props.setNuccDataPath;

    const [nuccUrl, setNuccUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''})
    const [reset, setReset] = useState(new Date().getTime());


    useEffect(() => {
        getNuccLink();
    }, [reset])

    const handleSubmit = (event) => {
        event.preventDefault();
        let fileUrls = {};
        const form = urlRef.current;
        let nuccURLs = form['url'].value;
        const pattern = /\/$/;

        if (!nuccURLs) {
            setSnackbarMsg({open: true, msg: 'No URL found', msgLv: 'error'})
            handleReset();
        } else {
            // check if the user input includes a '/' in the last character
            if (pattern.test(nuccURLs)) {
                nuccURLs = nuccURLs.slice(0, -1);
            }
            fileUrls['individual'] = `${nuccURLs}${individualSuffix}`;
            fileUrls['nonIndividual'] = `${nuccURLs}${nonIndividualSuffix}`;
            setNuccDataPath(fileUrls);
        }
    }

    const getNuccLink = async () => {
        const url = ApiUrl.ExternalSource.getLink.getPath('VS-NUCC-URL');

        try {
            setLoading(true);
            const res = await fetch(url);
            const data = await handleHttpResponse(res);
            setNuccUrl(data.value);
        } catch (err) {
            console.error(err);
            setSnackbarMsg({open: true, msg: 'Failed to get NUCC import link', msgLv: 'error'});
        } finally {
            setLoading(false);
        }
    }

    const handleSaveLink = async () => {

        const requestOption = {
            method: 'POST',
            headers: {'Content-Type': 'text/plain'},
            body: nuccUrl
        }

        const url = ApiUrl.ExternalSource.saveLink.getPath('VS-NUCC-URL', 'Database');

        try {
            setLoading(true);
            const res = await fetch(url, requestOption);
            const data = await handleHttpResponse(res);
            setSnackbarMsg({ open: true, msg: `Successfully save the link: ${nuccUrl}`, msgLv: 'success'});
            console.log("Successfully save the link: " + data.value)
        } catch (err) {
            console.error(err);
            setSnackbarMsg({ open: true, msg: `Failed to save the link: ${nuccUrl}`, msgLv: 'error'});
        } finally {
            setLoading(false);
        }

    }

    const handleReset = () => {
        setReset(new Date().getTime());
        setNuccDataPath({})
    }

    return (
        <div style={{marginBottom: '10px'}}>
            <StyledPaper
                component="form"
                elevation={3}
                onSubmit={handleSubmit}
                ref={urlRef}
            >
                <InputBase
                    sx={{ ml: 1, flex: 1}}
                    value={nuccUrl ?? ""}
                    name="url"
                    autoComplete="off"
                    onChange={(event) => setNuccUrl(event.target.value)}
                />
                <StyledDivider orientation="vertical" />
                <Tooltip title="Create CSV File URL" arrow>
                    <IconButton
                        type="submit"
                        sx={{ p: '10px'}}
                        aria-label="search"
                    >
                        <KeyboardReturnIcon color='primary'/>
                    </IconButton>
                </Tooltip>
                <StyledDivider orientation="vertical" />
                <Tooltip title='Save the link' arrow>
                    <IconButton onClick={handleSaveLink}>
                        <SaveIcon sx={{ color: pink[300]}}/>
                    </IconButton>
                </Tooltip>
                <StyledDivider orientation="vertical"/>
                <Tooltip title="Reset the CSV File Url">
                    <IconButton onClick={handleReset}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </StyledPaper>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={loading} />
        </div>
    )
}